export const USERS_ENDPOINTS = {
  USERS: 'users/users/',
  GRANTED_GROUPS: 'users/permission-groups-sets/',
  ROLES: 'roles-and-permissions/roles/',
  LOGIN: 'users/login',
};
